<template>
    <div>
        <div v-if="displaySupervisorsSummary && getSupervisorProposalsCount() > 0">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <h3 class="text-center">Resumo supervisor: {{ getSupervisorName() }}</h3>
                        <table class="table">
                            <thead class="thead-dark">
                                <tr>
                                    <th>Resumo das Vendas</th>
                                    <th class="text-center">Créditos</th>
                                    <th class="text-center">Porcentagem</th>
                                    <th class="text-center">Comissão</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="administrator in administrators" :key="'creditos_' + administrator.id.toString()">
                                    <td>Total de créditos vendidos {{ administrator.name }}</td>
                                    <td class="text-center">R$ {{ getSupervisorTotal(administrator.id) | price }}</td>
                                    <td class="text-center">{{ getSupervisorCommissionTotal(administrator.id) / Math.max(1,getSupervisorTotal(administrator.id)) * 100 | percent(2) }} %</td>
                                    <td class="text-center">R$ {{ getSupervisorCommissionTotal(administrator.id) | price }}</td>
                                </tr>
                                <tr>
                                    <td>Total bruto</td>
                                    <td class="text-center">R$ {{ getSupervisorTotal() | price }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorCommissionTotal() | price }}</td>
                                </tr>
                                <tr v-if="!isAlternateLayout">
                                    <td>Estornos</td>
                                    <td class="text-center">R$ {{ getSupervisorChargebackTotal() | price }}</td>
                                    <td class="text-center">{{ getSupervisorChargebackCommissionTotal() / Math.max(1,getSupervisorChargebackTotal()) * 100 | percent(2) }} %</td>
                                    <td class="text-center">R$ {{ getSupervisorChargebackCommissionTotal() | price }}</td>
                                </tr>
                                <tr v-if="getSupervisorExtraRewardAmount(1) > 0">
                                    <td>{{ getSupervisorExtraRewardName(1) || 'Premiação Extra' }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorExtraRewardAmount(1) | price }}</td>
                                </tr>
                                <tr v-if="getSupervisorExtraRewardAmount(2) > 0">
                                    <td>{{ getSupervisorExtraRewardName(2) || 'Premiação Extra' }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorExtraRewardAmount(2) | price }}</td>
                                </tr>
                                <tr v-if="getSupervisorExtraRewardAmount(3) > 0">
                                    <td>{{ getSupervisorExtraRewardName(3) || 'Premiação Extra' }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorExtraRewardAmount(3) | price }}</td>
                                </tr>
                                <tr v-if="getSupervisorPastChargebackAmount() > 0">
                                    <td>{{ getSupervisorPastChargebackName() || 'Estorno Retroativo' }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorPastChargebackAmount() | price }}</td>
                                </tr>
                                <tr>
                                    <td>Total líquido</td>
                                    <td class="text-center">R$ {{ getSupervisorTotal() - getSupervisorChargebackTotal() | price }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center">R$ {{ getSupervisorCommissionTotal() - getSupervisorChargebackCommissionTotal() + getSupervisorExtraRewardAmount() - getSupervisorPastChargebackAmount() | price }}</td>
                                </tr>
                                <tr>
                                    <td>Total comissão paga para vendedores</td>
                                    <td class="text-center">R$ {{ getNotSupervisorCommissionTotal() | price }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                                <tr v-if="isAlternateLayout">
                                    <td>Total de comissões pagas</td>
                                    <td class="text-center">R$ {{ getNotSupervisorCommissionTotal() + getSupervisorCommissionTotal() - getSupervisorChargebackCommissionTotal() + getSupervisorExtraRewardAmount() - getSupervisorPastChargebackAmount() | price }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                                <tr v-if="getSupervisorCommissionRuleText()">
                                    <td colspan="4" v-html="getSupervisorCommissionRuleText()"></td>
                                </tr>
                                <tr>
                                    <td>Qtde vendedores</td>
                                    <td class="text-center">{{ getNotSupervisorCount() }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                                <tr v-for="administrator in administrators" :key="'propostas_' + administrator.id.toString()">
                                    <td>Qtde contratos {{ administrator.name }}</td>
                                    <td class="text-center">{{ getSupervisorProposalsCount(administrator.id) }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Total contratos</td>
                                    <td class="text-center">{{ getSupervisorProposalsCount() }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                                <tr>
                                    <td>Ticket médio</td>
                                    <td class="text-center">R$ {{ getSupervisorTotal() / getSupervisorProposalsCount() | price }}</td>
                                    <td class="text-center"></td>
                                    <td class="text-center"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-md-6 offset-md-6 text-center">
                                __________________________________________________________________<br />
                                ASSINATURA {{ getSupervisorName() }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="panel panel-default">
                <div class="panel-body">
                    <h3 class="text-center">Resumo geral</h3>
                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th class="text-center" rowspan="2">Nome</th>
                                <th class="text-center" rowspan="2">Vendas</th>
                                <th class="text-center" rowspan="2">Ticket Médio</th>
                                <th class="text-center" colspan="2" v-if="hasExtraReward()">Premiação Extra</th>
                                <th class="text-center" colspan="2" v-if="hasPastChargeback()">Estorno Retroativo</th>
                                <th class="text-center" colspan="3" v-if="!isCondensedReport">Totais</th>
                                <th class="text-center" rowspan="2" v-if="isCondensedReport">Total</th>
                            </tr>
                            <tr>
                                <th class="text-center" v-if="hasExtraReward()">Descrição</th>
                                <th class="text-center" v-if="hasExtraReward()">Valor</th>
                                <th class="text-center" v-if="hasPastChargeback()">Descrição</th>
                                <th class="text-center" v-if="hasPastChargeback()">Valor</th>
                                <th class="text-center" v-if="!isCondensedReport">Comissão</th>
                                <th class="text-center" v-if="!isCondensedReport">Prêmio por Volume</th>
                                <th class="text-center" v-if="!isCondensedReport">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items">
                                <td>{{ item.name }}</td>
                                <td class="text-center">R${{ item.valorTotal | price }}</td>
                                <td class="text-center">R${{ item.valorTotal / item.proposalsAmount | price }}</td>
                                <td class="text-center" v-if="hasExtraReward() && getExtraRewardAmount(item.salesmanId) > 0">{{ getExtraRewardName(item.salesmanId) }}</td>
                                <td class="text-center" v-if="hasExtraReward() && getExtraRewardAmount(item.salesmanId) == 0">--</td>
                                <td class="text-center" v-if="hasExtraReward() && getExtraRewardAmount(item.salesmanId) > 0">R${{ getExtraRewardAmount(item.salesmanId) | price }}</td>
                                <td class="text-center" v-if="hasExtraReward() && getExtraRewardAmount(item.salesmanId) == 0">--</td>
                                <td class="text-center" v-if="hasPastChargeback() && getPastChargebackAmount(item.salesmanId) == 0">--</td>
                                <td class="text-center" v-if="hasPastChargeback() && getPastChargebackAmount(item.salesmanId) > 0">{{ getPastChargebackName(item.salesmanId) }}</td>
                                <td class="text-center" v-if="hasPastChargeback() && getPastChargebackAmount(item.salesmanId) == 0">--</td>
                                <td class="text-center" v-if="hasPastChargeback() && getPastChargebackAmount(item.salesmanId) > 0">R${{ getPastChargebackAmount(item.salesmanId) | price }}</td>
                                <td class="text-center" v-if="!isCondensedReport">R${{ item.commissionTotal | price }}</td>
                                <td class="text-center" v-if="!isCondensedReport">R${{ item.volumeTotal | price }}</td>
                                <td class="text-center">R${{ item.commissionTotal + item.volumeTotal + getExtraRewardAmount(item.salesmanId) - getPastChargebackAmount(item.salesmanId) | price }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td class="text-center">R${{ items.reduce((a, b) => ({valorTotal: a.valorTotal + b.valorTotal}), {valorTotal: 0}).valorTotal | price }}</td>
                                <td class="text-center">R${{ items.reduce((a, b) => ({valorTotal: a.valorTotal + b.valorTotal}), {valorTotal: 0}).valorTotal / items.reduce((a, b) => ({proposalsAmount: a.proposalsAmount + b.proposalsAmount}), {proposalsAmount: 0}).proposalsAmount | price }}</td>
                                <td class="text-center" v-if="hasExtraReward()">--</td>
                                <td class="text-center" v-if="hasExtraReward()">R${{ getExtraRewardTotal() | price }}</td>
                                <td class="text-center" v-if="hasPastChargeback()">--</td>
                                <td class="text-center" v-if="hasPastChargeback()">R${{ getPastChargebackTotal() | price }}</td>
                                <td class="text-center" v-if="!isCondensedReport">R${{ items.reduce((a, b) => ({commissionTotal: a.commissionTotal + b.commissionTotal}), {commissionTotal: 0}).commissionTotal | price }}</td>
                                <td class="text-center" v-if="!isCondensedReport">R${{ items.reduce((a, b) => ({volumeTotal: a.volumeTotal + b.volumeTotal}), {volumeTotal: 0}).volumeTotal | price }}</td>
                                <td class="text-center">R${{ (items.reduce((a, b) => ({commissionTotal: a.commissionTotal + b.commissionTotal}), {commissionTotal: 0}).commissionTotal + items.reduce((a, b) => ({volumeTotal: a.volumeTotal + b.volumeTotal}), {volumeTotal: 0}).volumeTotal) + getExtraRewardTotal() - getPastChargebackTotal() | price }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash'
    export default {
        computed: {
            isCondensedReport: function () {
                return Boolean(this.$store.state.configurations.model.condensed_analytical_commission_by_profile_report);
            },
            displaySupervisorsSummary: function () {
                return Boolean(this.$store.state.configurations.model.display_supervisor_summary_on_analytical_commission_by_profile_report);
            },
            isAlternateLayout: function () {
                return Boolean(this.$store.state.configurations.model.analytical_commission_by_profile_report_alternate_layout);
            },
            items: {
                get () {
                    const items = [];

                    const report = this.$store.state.reports.items;
                    report.map(_report => {
                        const item = items.find(_item => _item.name == _report.name);
                        if (item == undefined) {
                            items.push({
                                name: _report.name,
                                profile: _report.profile,
                                valorTotal: _report.valorTotal,
                                commissionTotal: _report.commissionTotal,
                                volumeTotal: _report.volumeTotal,
                                proposalsAmount: _report.proposalsAmount,
                                salesmanId: _report.profile == 'supervisor' ? _report.supervisorId : _report.salesmanId,
                                supervisorId: _report.supervisorId,
                            });
                        } else {
                            item.valorTotal += _report.valorTotal;
                            item.commissionTotal += _report.commissionTotal;
                            item.volumeTotal += _report.volumeTotal;
                            item.proposalsAmount += _report.proposalsAmount;
                        }
                    });

                    items.sort((a, b) => {
                        if (a.name == b.name) {
                            return 0;
                        }
                        return a.name > b.name ? 1 : -1;
                    });

                    return items;
                }
            },
            administrators: function () {
                return this.$store.state.administrators.itens;
            },
        },
        data () {
            return {
                profiles: {
                    'admin': 'Administrador',
                    'manager': 'Gerente',
                    'supervisor': 'Supervisor',
                    'salesman': 'Vendedor',
                    'after_sale': 'Pós Venda',
                }
            };
        },
        methods: {
            hasExtraReward() {
                return this.$parent.hasExtraReward(this.items);
            },
            getExtraRewardAmount(salesmanId) {
                return this.$parent.getExtraRewardAmount(salesmanId);
            },
            getExtraRewardName(salesmanId) {
                return this.$parent.getExtraRewardName(salesmanId);
            },
            getExtraRewardTotal() {
                return this.$parent.getExtraRewardTotal(this.items);
            },
            hasPastChargeback() {
                return this.$parent.hasPastChargeback(this.items);
            },
            getPastChargebackName(salesmanId) {
                return this.$parent.getPastChargebackName(salesmanId);
            },
            getPastChargebackAmount(salesmanId) {
                return this.$parent.getPastChargebackAmount(salesmanId);
            },
            getPastChargebackTotal() {
                return this.$parent.getPastChargebackTotal(this.items);
            },
            getSupervisorTotal(administratorId) {
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile != 'supervisor') {
                            return sum;
                        }
                        if (administratorId && personTotals.administratorId != administratorId) {
                            return sum;
                        }
                        return sum + personTotals.valorTotal;
                    },
                    0
                );
            },
            getSupervisorCommissionTotal(administratorId) {
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile != 'supervisor') {
                            return sum;
                        }
                        if (administratorId && personTotals.administratorId != administratorId) {
                            return sum;
                        }
                        return sum + personTotals.commissionTotal + personTotals.volumeTotal + personTotals.chargeback;
                    },
                    0
                );
            },
            getSupervisorName() {
                let nameSupervisor = ""
                if (this.$store.state.reports.item.length > 0) {
                    let numProposals = 0
                    const supervisors = this.$store.state.reports.item[0].proposals.supervisors
                    Object.keys(supervisors).forEach(key => {
                        let supervisor = supervisors[key]
                        if (numProposals < supervisor.length) {
                            numProposals = supervisor.length
                            nameSupervisor = key
                        }
                    })
                }
                return nameSupervisor;
            },
            getSupervisorProposalsCount(administratorId) {
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile != 'supervisor') {
                            return sum;
                        }
                        if (administratorId && personTotals.administratorId != administratorId) {
                            return sum;
                        }
                        return sum + personTotals.proposalsAmount;
                    },
                    0
                );
            },
            getSupervisorChargebackTotal() {
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile != 'supervisor') {
                            return sum;
                        }
                        return sum + personTotals.chargebackProposals;
                    },
                    0
                );
            },
            getSupervisorChargebackCommissionTotal() {
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile != 'supervisor') {
                            return sum;
                        }
                        return sum + personTotals.chargeback;
                    },
                    0
                );
            },
            getSupervisorId() {
                return this.$store.state.reports.items[0].supervisorId;
            },
            getSupervisorExtraRewardAmount(which) {
                return this.$parent.getExtraRewardAmount(this.getSupervisorId(), which);
            },
            getSupervisorExtraRewardName(which) {
                return this.$parent.getExtraRewardName(this.getSupervisorId(), which);
            },
            getSupervisorCommissionRuleText() {
                return this.$parent.getCommissionRuleText(this.getSupervisorId());
            },
            getSupervisorPastChargebackName() {
                return this.$parent.getPastChargebackName(this.getSupervisorId());
            },
            getSupervisorPastChargebackAmount() {
                return this.$parent.getPastChargebackAmount(this.getSupervisorId());
            },
            getNotSupervisorCommissionTotal() {
                const uniqueIds = [];
                return this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile == 'supervisor') {
                            return sum;
                        }
                        let extraRewardsAmount = 0;
                        let pastChargebackAmount = 0;
                        if (uniqueIds.find(id => id == personTotals.salesmanId) === undefined) {
                            uniqueIds.push(personTotals.salesmanId);
                            extraRewardsAmount = this.getExtraRewardAmount(personTotals.salesmanId);
                            pastChargebackAmount = this.getPastChargebackAmount(personTotals.salesmanId);
                        }
                        return sum + personTotals.commissionTotal + personTotals.volumeTotal + extraRewardsAmount - pastChargebackAmount;
                    },
                    0
                );
            },
            getNotSupervisorCount() {
                const uniqueIds = [];
                const count = this.$store.state.reports.items.reduce(
                    (sum, personTotals) => {
                        if (personTotals.profile == 'supervisor') {
                            return sum;
                        }
                        if (uniqueIds.find(id => id == personTotals.salesmanId) === undefined) {
                            uniqueIds.push(personTotals.salesmanId);
                            return sum + 1;
                        }
                        return sum;
                    },
                    0
                );

                return count;
            }
        },
    };
</script>